/* eslint-disable camelcase */
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { registerEvents } from 'services/api/marketing-api'

function useMetaEventsSave() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationKey: ['save-meta-events'],
    mutationFn: ({ channels, department_ids, event_id }) => registerEvents({ channels, department_ids, event_id }),
    onMutate: async () => {
      await queryClient.cancelQueries({ queryKey: ['get-events-list'] })
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['get-events-list'] })
    },
  })
}

export default useMetaEventsSave
